import React, { Component } from "react"
import { withStyles } from "@material-ui/core"
import * as constants from "../constants"
import { Cookies } from "react-cookie"
import Grid from "@material-ui/core/Grid"
import Divider from "@material-ui/core/Divider"
import FloatingLabelInput from "./FloatingLabelInput"
import Select from "react-select"
import Button from "@material-ui/core/Button"
import Fab from "@material-ui/core/Fab"
import EditIcon from "@material-ui/icons/Edit"
import DeleteIcon from "@material-ui/icons/Delete"
import Snackbar from "@material-ui/core/Snackbar"
import { Alert, AlertTitle } from "@material-ui/lab"

const styles = (theme) => ({
      button: {
            margin: theme.spacing.unit,
      },
      small: {
            width: theme.spacing(6),
            height: theme.spacing(6),
      },
})

class ElevatorKindRespons extends Component {
      cookies = new Cookies()
      constructor(props) {
            super(props)

            this.state = {
                  thirdpartyPriceDiscState: this.props.elevatorKindRespons,

                  selectedElevatorKindRespons: {
                        value: this.props.elevatorKindRespons.elevator_price_kindrespons_elevator_kindrespons_id,
                        label: this.props.elevatorKindRespons.elevator_kindrespons_name,
                  },
                  visible: true,
                  snackstr: "",
                  showSnack: false,
                  snackMode: "success",
                  optionElevatorKindRespons: [],
            }
      }
      componentDidMount() {
            this.getoptionElevatorKindRespons()
      }



      getoptionElevatorKindRespons = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Company = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({ value: arr.data[k].elevator_kindrespons_id, label: arr.data[k].elevator_kindrespons_name })
                              }
                              self.setState({ optionElevatorKindRespons: Company }, () => {})
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_elevator_kindrespons")
            xhttp.open("POST", `${constants.BASE_URL}/elevator`)
            xhttp.send(fd)
      }

      handleClickcloseTasckBar = (event) => {
            this.setState({ showSnack: false })
      }



      handleElevatorKindRespons  = (selectedElevatorKindRespons) => {
            var temparray = this.state.thirdpartyPriceDiscState
            temparray.elevator_price_kindrespons_elevator_kindrespons_id = selectedElevatorKindRespons.value
            this.setState({ selectedElevatorKindRespons: selectedElevatorKindRespons, thirdpartyPriceDiscState: temparray })
      }

      handleChangeKindresponsPrice = (event) => {
            var temparray = this.state.thirdpartyPriceDiscState
            temparray.elevator_price_kindrespons_price = event
            this.setState({ thirdpartyPriceDiscState: temparray })
      }



      modifyNewInstalmentCondition = () => {
            const { thirdpartyPriceDiscState } = this.state

            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        console.log(this.responseText)
                        var arr = JSON.parse(this.responseText)
                        console.log(arr)
                        if (arr.result === "ok") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "modify_price_kindrespons")
            fd.append("elevator_price_kindrespons_id", thirdpartyPriceDiscState.elevator_price_kindrespons_id)
            fd.append("elevator_price_kindrespons_elevator_kindrespons_id", thirdpartyPriceDiscState.elevator_price_kindrespons_elevator_kindrespons_id)
            fd.append("elevator_price_kindrespons_price", thirdpartyPriceDiscState.elevator_price_kindrespons_price)

            xhttp.open("POST", `${constants.BASE_URL}/elevator`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      deleteInstalmentCondition = () => {
            const { thirdpartyPriceDiscState } = this.state

            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        console.log(arr)
                        if (arr.result === "ok") {
                              self.setState({ visible: false, snackstr: arr.desc, showSnack: true, snackMode: "success" })
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "delete_price_kindrespons")
            fd.append("elevator_price_kindrespons_id", thirdpartyPriceDiscState.elevator_price_kindrespons_id)

            xhttp.open("POST", `${constants.BASE_URL}/elevator`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      render() {
            const { classes } = this.props
            const { optionElevatorKindRespons , snackMode, snackstr, showSnack, visible , selectedElevatorKindRespons, thirdpartyPriceDiscState } = this.state
            if (visible) {
                  return (
                        <Grid container spacing={3}>
                              <Snackbar
                                    anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                                    onClose={this.handleClickcloseTasckBar}
                                    open={showSnack}
                                    autoHideDuration={10000}
                              >
                                    <Alert severity={snackMode}>{snackstr}</Alert>
                              </Snackbar>

                              <Grid item xs={4}>
                                    <div>
                                          <label className="on">پوشش بیمه نامه </label>
                                          <Select
                                                isSearchable={true}
                                                className="adapter-txtsize"
                                                placeholder={"پوشش بیمه نامه"}
                                                value={selectedElevatorKindRespons}
                                                onChange={this.handleElevatorKindRespons }
                                                options={optionElevatorKindRespons}
                                          />
                                    </div>
                              </Grid>





                              <Grid item xs={4}>
                                    <FloatingLabelInput
                                        type="percent"
                                        placeholder="درصد اضافه نرخ"
                                        handleInputt={this.handleChangeKindresponsPrice}
                                        value={thirdpartyPriceDiscState.elevator_price_kindrespons_price}
                                    />
                              </Grid>

                              <Grid item xs={4}>
                                    <div style={{ width: "100%", textAlign: "left" }}>
                                          <Fab
                                                className={classes.small}
                                                style={{ background: "#44b700" }}
                                                aria-label="edit"
                                                onClick={this.modifyNewInstalmentCondition}
                                          >
                                                <EditIcon />
                                          </Fab>

                                          <Fab className={classes.small} color="secondary" aria-label="edit" onClick={this.deleteInstalmentCondition}>
                                                <DeleteIcon />
                                          </Fab>
                                    </div>
                              </Grid>
                              <Grid item xs={12}>
                                    <Divider />
                              </Grid>
                        </Grid>
                  )
            } else {
                  return null
            }
      }
}
export default withStyles(styles)(ElevatorKindRespons)
